import { makeAutoObservable, reaction } from 'mobx';

import { TReverseParam, reverseParams } from 'constants/extraParams';
import { RootStore } from 'store/RootStore';
import { SiteFeaturesIDs } from 'store/SiteFeatures/SiteFeatures';

type TReverseMode = 'include' | 'exclude';
type TModes = Record<TReverseParam, TReverseMode | null>;

const getDefaultModes = () => Object.fromEntries(Object.values(reverseParams).map(param => [param, null])) as TModes;

class ReverseParams {
  root: RootStore;
  modes: TModes;

  constructor(root: RootStore) {
    this.root = root;
    this.modes = getDefaultModes();

    makeAutoObservable(this);

    reaction(
      () => this.isIncluded(reverseParams.adr),
      isIncluded => {
        if (!isIncluded) {
          this.root.filter.ADR.clear();
        }
      },
    );
  }

  get isEnabled() {
    return Boolean(this.root.siteFeatures.isSiteFeatureEnabled[SiteFeaturesIDs.reverseFilters]);
  }

  get excludedCount() {
    return Object.values(this.modes).filter(mode => mode === 'exclude').length;
  }

  get isDefault() {
    return Object.values(this.modes).every(mode => mode === null);
  }

  isIncluded = (param: TReverseParam) => this.modes[param] === 'include';

  isExcluded = (param: TReverseParam) => this.modes[param] === 'exclude';

  setMode = (param: TReverseParam, mode: TReverseMode) => {
    this.modes[param] = this.modes[param] === mode ? null : mode;
  };

  reset = () => {
    (Object.keys(this.modes) as TReverseParam[]).forEach(param => {
      this.modes[param] = null;
    });
  };
}

export { ReverseParams };
